import axios from 'axios';
import Home from './main-views/Home';
import AboutUs from './main-views/AboutUs';
import ContactUs from './main-views/ContactUs';
import Services from './main-views/Services';
import Careers from './main-views/Careers';
import JobOptions from './views/JobOptions';
import CreateApplication from './views/CreateApplication';
import MyApplication from './views/MyApplication';
import EditApplicantProfile from './ones/EditApplicantProfile';


export const BASE_API = '';

export const PUBLIC_API = 'https://nangubaapi.werenium.com/api/public/';

export const JOB_API = 'https://nangubaapi.werenium.com/api/jobapplicant/';

export const CDN_URL = 'https://nangubahealth.com/cdn';


export function getMainView(app) {
  if (app.navItem === 'home') {
    return <Home />
  } else if (app.navItem === 'about_us') {
    return <AboutUs />
  } else if (app.navItem === 'contact_us') {
    return <ContactUs />
  } else if (app.navItem === 'services') {
    return <Services />
  } else if (app.navItem === 'careers') {
    return <Careers />
  } else {
    //default home
    return <Home />
  }

  return null;
}

export function getViewerView(app) {
  

  return null;
}

export function getSideViewerView(app) {
  if(
    app.navSubItem === 'job-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <JobOptions uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'create-application' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <CreateApplication uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'my-applications' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <MyApplication uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'edit-applicant-profile' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <EditApplicantProfile uuid={app.navExtraItem}/>
  } 

  return null;
}


export function getInlineLoader() {
  return (
    <div className="Loader"></div>
  )
}


export function formatDate(timestamp, fromPhp = true) {
  timestamp = (fromPhp) ? Number(timestamp) * 1000 : timestamp;
  let date = new Date(timestamp);
  return (date.toLocaleString());
}

export function callApi(url, params) {
  return new Promise(async resolve => {
    await getLocalUser().then(user => {
      
      // 1. Determine the correct Base URL and clean the endpoint path
      let finalUrl = '';
      if (url.startsWith('jobapplicant/')) {
        finalUrl = JOB_API + url.replace('jobapplicant/', '');
      } else if (url.startsWith('public/')) {
        finalUrl = PUBLIC_API + url.replace('public/', '');
      } else {
        finalUrl = PUBLIC_API + url;
      }

      let attempt = 0;
      const maxRetries = 3;

      // Wrap the generation block inside the request loop execution
      const makeRequest = async () => {
        
        // 2. CRITICAL: Freshly construct a clean payload boundary on EVERY retry attempt
        let formData = new FormData();
        formData.append('language', getCookie('language'));

        // 3. CRITICAL: Append user auth tokens at the very TOP of the stream layout
        // This ensures the backend reads user credentials instantly even if a file stream stutters
        for (let key in user) {
          const value = user[key];
          if (value !== undefined && value !== null && value !== '') {
            formData.append(key, value);
          }
        }

        // 4. Safely handle input parameters and files
        for (let key in params) {
          const value = params[key];
          if (value === undefined || value === null) continue;

          if (value instanceof File) {
            formData.append(key, value);
          }
          else if (value instanceof FileList) {
            Array.from(value).forEach(file => {
              formData.append(key, file);
            });
          }
          else {
            formData.append(key, value);
          }
        }

        try {
          // 5. Explicitly pass undefined Content-Type header config
          // This forces Axios to compute accurate browser multi-part boundaries dynamically
          const response = await axios.post(finalUrl, formData, {
            headers: {
              "Content-Type": undefined
            }
          });
          
          console.log(url, response.data);
          resolve(response.data); 
        } catch (error) {
          attempt++;
          if (attempt < maxRetries) {
            console.log(`Attempt ${attempt} failed. Re-building payload stream and retrying...`);
            // Add a small 400ms delay to give the network socket time to clean up
            setTimeout(makeRequest, 400); 
          } else {
            resolve({
              status: 0,
              msg: "Network Connection Error after 3 attempts",
            }); 
          }
        }
      };

      makeRequest();
    });
  });
}

export function getLocalUser() {

  let userUuid = getCookie('userUuid');
  let userToken = getCookie('userToken');
  let userType = getCookie('userType');

  return Promise.resolve({
    userUuid,
    userToken,
    userType
  });
}

export function setCookie(cname, cvalue, exdays) {
  cname = 'Nanguba-user-'+cname;
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  const prefix = 'Nanguba-user-';
  const name = prefix + cname + "=";

  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();

    if (c.indexOf(name) === 0) {
      return c.substring(name.length);
    }
  }

  return "";
}

export function formatMoney(x) {
  //round x to 2 decimal places before og function
  x = Number(x);
  x = x.toFixed(0);

  //then continue
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function formatMoneyShorten(num, digits = 2) {
  num = Number.parseFloat(num);
  if (num <= 1 && num >= -1) {
    return num;
  }

  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function (item) {
    return Math.abs(num) >= item.value; // Use absolute value of num
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export function stringToArray(string) {
  const array = string.split(",").map(item => item.trim());
  return array;
}

export function arrayToString(arr) {
  return arr.join(', ');
}

export function getCurrentYear() {
  return new Date().getFullYear();
}
